import React, { useEffect, useState } from "react";
import Navigation from "../Navigation/Navigation";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { Button, Col, Row } from "react-bootstrap";
import PaymentsTypes from "./PaymentsTypes";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { PlanDetailsApi } from "../../Utils/Api/PlanDetailsApi";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";
import deleter from "../../assets/delete.svg";
import { DeleteModal } from "../../Components/Modals/DeleteModal";
import { GetCardDetailsApi } from "../../Utils/Api/GetCardDetailsApi";
import { UpdateDefaultCardApi } from "../../Utils/Api/UpdateDefaultCardApi";
import warningSymbol from "../../assets/warningIcon.svg";
import { DeleteCardApi } from "../../Utils/Api/DeleteCardApi";
import { ConfirmationModalPopUp } from "../../Components/Modals/ConfirmationModalPopUp";
import { ChargeBeeSubscriptionApi } from "../../Utils/Api/ChargeBeeSubscriptionApi";
import primaryCard from "../../assets/primaryCard.png";
import defaultCardImage from "../../assets/cardImage.svg";
import visaCard from "../../assets/visa.png";
import maestroCard from "../../assets/Maestro.png";
import masterCard from "../../assets/mastercard.png";
import discoverCard from "../../assets/discover.png";
import americanExpressCard from "../../assets/american-express.png";
import dinersClubCard from "../../assets/dinersclub.png";
import jcbCard from "../../assets/jcb.png";
import unionPayCard from "../../assets/UnionPay.png";
import { userId } from "../../Utils/LocalStorage";
import {
  getMySubscriptionPlan,
  getMySubscriptionPlanName,
} from "../../redux/MyProfileSubscriptionSlice";
import { couponApi } from "../../Utils/Api/couponApi";
import StripeModal from "../../Components/Modals/StripeModal";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import { DiscountedDetailsApi } from "../../Utils/Api/DiscountedDetailsApi";

const CheckOutPage = () => {
  const [currentTab, setcurrentTab] = useState("");
  const [planDetails, setPlanDetails] = useState({});
  const [cardDetails, setCardDetails] = useState([]);
  const [checked, setChecked] = useState(false);
  const [checkedIndex, setCheckedIndex] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalStripeShow, setStripeModalShow] = useState(false);
  const [confirmationModalShow, setConfirmationModalShow] = useState(false);
  const [cvv, setCvv] = useState("");
  const [cardID, setCardID] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [err, setErr] = useState(false);
  const [subscriptionCardId, setSubscriptionCardId] = useState("");
  const [subscriptionData, setSubscriptionData] = useState({});
  const [errDisplay, setErrorDisplay] = useState("");
  const [errorCoupon, setErrorCoupon] = useState("");
  const [couponData, setCouponData] = useState(null);
  const [applyButton, setApplyButton] = useState(false);
  const [discountedData, setDiscountedData] = useState("");

  const path = window.location.href;
  const endPath = path.split("/");

  const Uid = userId();

  // persisted Redux
  const data = useSelector((state) => state.PersistedData);

  const PlanId = data.MyProfileSubscription.MySubscriptionPlanId;

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const CvvHandler = (e) => {
    let val = e.target.value.replace(/\D/g, "").slice(0, 4);
    setErr(false);
    setCvv(val);
  };

  // Stripe integration
  const checkoutHandler = (e) => {
    e.preventDefault();
    setStripeModalShow(true);
  };

  // Cancel function
  const cancelHandler = () => {
    navigate("/my-profile/subscription/tier-details");
  };

  // Form check function
  const FormCheck = (e) => {
    let Checked = e.target.checked;
    setChecked(Checked);
  };

  // Pay function
  const PayHandler = (e) => {
    e.preventDefault();
    let check = true;

    if (!cvv) {
      setErr(true);
      check = false;
    } else {
      setErr(false);
    }

    if (cardDetails?.length === 0) {
      setErrorDisplay("Please add the card details!");
      check = false;
    } else if (checkedIndex === -1) {
      setErrorDisplay("Please select a card for payment!");
      check = false;
    } else if (!cvv) {
      setErrorDisplay("Please enter CVV!");
      check = false;
    } else if (checked !== true) {
      setErrorDisplay("Please accept the terms & conditions!");
      check = false;
    } else {
      setErrorDisplay("");
    }

    if (checked === true && checkedIndex !== -1 && check === true) {
      const data = {
        user_id: parseInt(Uid),
        plan_id: PlanId,
        card_id: subscriptionCardId,
        cvv: cvv,
      };
      setSubscriptionData(data);
      setConfirmationModalShow(true);
    }
  };

  // Make it primary function
  const UpdateDefaultCardHandler = (e, cardId) => {
    let check = e.target.checked;

    if (check === true) {
      const data = {
        user_id: Uid,
        card_id: cardId,
      };
      UpdateDefaultCard(data);
    }
  };

  // Card selector function
  const CardSelectHandler = (i, CardID) => {
    setErr(false);
    setCheckedIndex(i);
    setSubscriptionCardId(CardID);
    setCvv("");
  };

  // DeleteCard Function
  const DeleteCardHandler = (CardId) => {
    const data = {
      user_id: Uid,
      card_id: parseInt(CardId),
    };

    DeleteCard(data);
  };

  ////////////////////////////////////////////// API's ////////////////////////////////////////////////////

  const PlanDetails = async () => {
    const data = {
      plan_id: PlanId,
    };

    setLoading(true);
    const PlanDetailsRes = await PlanDetailsApi(data, () => {
      navigate("/");
    });

    if (PlanDetailsRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (PlanDetailsRes.success === true) {
        setPlanDetails(PlanDetailsRes.data[0]);
        setLoading(false);
      } else if (PlanDetailsRes.status === 429) {
        setLoading(true);
        toast.error(PlanDetailsRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        setPlanDetails({});
        setLoading(false);
      }
    }
  };

  const GetCardDetails = async () => {
    const data = {
      user_id: Uid,
    };
    setLoading(true);
    const GetCardDetailsRes = await GetCardDetailsApi(data, () => {
      navigate("/");
    });
    if (GetCardDetailsRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (GetCardDetailsRes.success === true) {
        setCardDetails(GetCardDetailsRes.data);
        const initialSwitchValues = GetCardDetailsRes.data.findIndex(
          (item) => item.is_default === 1
        );
        GetCardDetailsRes.data.filter((item) => {
          if (item.is_default === 1) {
            setSubscriptionCardId(item.business_card_id);
          }
        });
        setCheckedIndex(initialSwitchValues);
      } else if (GetCardDetailsRes.status === 429) {
        setLoading(true);
        toast.error(GetCardDetailsRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        setCardDetails([]);
        setLoading(false);
      }
    }
  };

  // Update Card API
  const UpdateDefaultCard = async (data) => {
    setLoading(true);
    const UpdateDefaultCardRes = await UpdateDefaultCardApi(data, () => {
      navigate("/");
    });
    if (UpdateDefaultCardRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (UpdateDefaultCardRes.success === true) {
        toast.success(UpdateDefaultCardRes.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        GetCardDetails();
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      } else {
        toast.error(UpdateDefaultCardRes.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  // Delete Card API
  const DeleteCard = async (data) => {
    setLoading(true);
    const DeleteCardRes = await DeleteCardApi(data, () => {
      navigate("/");
    });
    if (DeleteCardRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (DeleteCardRes.success === true) {
        toast.success(DeleteCardRes.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        GetCardDetails();
        setModalShow(false);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      } else {
        toast.error(DeleteCardRes.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  // Charge bee subscription API
  const ChargeBeeSubscription = async (data) => {
    setLoading(true);
    const ChargeBeeSubscriptionRes = await ChargeBeeSubscriptionApi(
      data,
      () => {
        navigate("/");
      }
    );

    if (ChargeBeeSubscriptionRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      navigate("/my-profile/transaction-failed");
      setLoading(false);
    } else {
      if (ChargeBeeSubscriptionRes.success === true) {
        dispatch(
          getMySubscriptionPlanName(
            data.plan_id === 1
              ? "You can create 1 voucher, 1 coupon and subscribe to 1 marketplace with this plan. T&C applied."
              : data.plan_id === 2
              ? "You can create up to 3 vouchers, 3 coupons and subscribe to 3 marketplaces with this plan. T&C applied."
              : "You can create unlimited vouchers & coupons and subscribe to all marketplaces with this plan. T&C applied."
          )
        );
        dispatch(
          getMySubscriptionPlan(
            data.plan_id === 1
              ? "Free"
              : data.plan_id === 2
              ? "Tier II"
              : "Tier III"
          )
        );
        navigate("/my-profile/transaction-successful");
        setConfirmationModalShow(false);
        setLoading(false);
      } else {
        toast.error(ChargeBeeSubscriptionRes.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  // apply coupon function
  const dataCoupon = useSelector((state) => state.PersistedData);
  const planId = dataCoupon?.MyProfileSubscription?.MySubscriptionPlanId;
  const user_id = userId();

  const alreadyApplied = () => {
    toast.success("Coupon applied already!", {
      position: "top-center",
      width: "500px",
      autoClose: 6000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  };

  const applyChangeHandler = (e) => {
    if (e.target.value !== "") {
      setCouponData(e.target.value);
    } else {
      setCouponData("");
    }
    setApplyButton(false);
    setErrorCoupon("");
    setDiscountedData("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      user_id: user_id,
      coupon_code: couponData,
      plan_id: planId,
    };
    if (couponData && couponData !== "") {
      couponApiHandler(data);
      setErrorCoupon("");
      return;
    } else {
      setErrorCoupon("Coupon code should not be empty");
    }
  };

  const couponApiHandler = async (data) => {
    const couponApires = await couponApi(data, () => {
      navigate("/");
    });

    if (couponApires === false) {
      // toast.error(ServerError, {
      //   position: "top-center",
      //   autoClose: 6000,
      //   hideProgressBar: true,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "dark",
      // });
      setErrorCoupon(couponApires.message);
    } else {
      if (couponApires.success === true) {
        // toast.success(couponApires.message, {
        //   position: "top-center",
        //   width: "500px",
        //   autoClose: 6000,
        //   hideProgressBar: true,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   theme: "dark",
        // });
        setErrorCoupon(
          couponApires.message === "Coupon applied"
            ? "Coupon applied successfully!"
            : ""
        );
        setApplyButton(true);
      }else if (couponApires.status === 429) {
        setLoading(true);
        toast.error(couponApires.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }   else {
        // toast.error(couponApires.message, {
        //   position: "top-center",
        //   autoClose: 6000,
        //   hideProgressBar: true,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   theme: "dark",
        // });
        setErrorCoupon(couponApires.message);
      }
    }
    if (couponData) {
      setDiscountedData(couponApires);
    } else {
      setDiscountedData();
    }
  };

  useEffect(() => {
    if (endPath[4] === "subscription") {
      setcurrentTab("subscription");
    }

    GetCardDetails();
    PlanDetails();
  }, []);

  return (
    <>
      {loading === true ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/my-profile/subscription/tier-details"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">My Profile</p>
          {/* {CheckChargebeeSubscriptionFlag && (
            <p className="app_locked_info_text">
              (Your account has been suspended as the grace period has ended.
              Please renew your plan to reactivate your account.)
            </p>
          )} */}
          <div className="acc-dashboard mt-4 checkoutpage-main">
            <div className="mb-2 tabs_ul">
              <NavLink to={"/my-profile/general-info"} className={"tabs_li"}>
                General Info
              </NavLink>
              <NavLink to={"/my-profile/business-info"} className={"tabs_li"}>
                Business Info
              </NavLink>
              <NavLink to={"/my-profile/store-info"} className={"tabs_li"}>
                Store Info
              </NavLink>
              <NavLink
                to={"/my-profile/subscription"}
                className={
                  currentTab === "subscription" ? " activeTab" : "tabs_li"
                }
              >
                Subscription
              </NavLink>
              {/* <NavLink to={"/my-profile/bank-info"} className={"tabs_li"}>
            Bank Info
          </NavLink> */}
              {/* <NavLink
                to={"/my-profile/transaction-history"}
                className={"tabs_li"}
              >
                Transaction History
              </NavLink> */}
              <NavLink
                to={"/my-profile/marketplace-membership"}
                className={"tabs_li"}
              >
                Marketplace Membership
              </NavLink>
            </div>

            <div className="mt-3 checkout-details">
              <h3>
                Yay ! we are updating your plan to{" "}
                {planDetails?.subscription_name
                  ? planDetails?.subscription_name
                  : ""}
              </h3>
              <p>
                Please accept the Terms & Conditions before placing the order.
              </p>
              <Row className="Payment-method">
                {/* <Col md={7}>
                  <h3>Payment method</h3>
                  <PaymentsTypes />
                  <Form className="passwordcheck mt-4 orange-check">
                    {cardDetails?.length > 0 ? (
                      cardDetails?.map((data, i) => {
                        let cardFourDigits = data.card_number?.slice(-4);

                        // card image function
                        const CardImageHandler = () => {
                          if (data?.card_type === "Unknown") {
                            return defaultCardImage;
                          } else if (data?.card_type === "Visa") {
                            return visaCard;
                          } else if (data?.card_type === "Mastercard") {
                            return masterCard;
                          } else if (data?.card_type === "Discover") {
                            return discoverCard;
                          } else if (data?.card_type === "American Express") {
                            return americanExpressCard;
                          } else if (data?.card_type === "Diners Club") {
                            return dinersClubCard;
                          } else if (data?.card_type === "JCB") {
                            return jcbCard;
                          } else if (data?.card_type === "Maestro") {
                            return maestroCard;
                          } else if (data?.card_type === "UnionPay") {
                            return unionPayCard;
                          } else {
                            return defaultCardImage;
                          }
                        };

                        const cardImage = CardImageHandler();
                        return (
                          <div
                            key={i}
                            className={
                              i === checkedIndex
                                ? "inner-checkout checkoutborder"
                                : data.is_default === 1
                                ? "inner-checkout primaryInput-box"
                                : "inner-checkout"
                            }
                          >
                            <div className="card-detail-checkout">
                              <Form.Check
                                name="grouped"
                                required
                                inline
                                label={"**** **** ****" + " " + cardFourDigits}
                                onChange={() =>
                                  CardSelectHandler(i, data.business_card_id)
                                }
                                type="radio"
                                isValid
                                checked={i === checkedIndex}
                              ></Form.Check>
                              <img
                                src={cardImage}
                                className="cardImage"
                                alt="cardImage"
                              />
                              {data.is_default === 1 ? (
                                <>
                                  <p className="primary-tag">
                                    Primary Card
                                    <img
                                      loading="lazy"
                                      src={primaryCard}
                                      className="primaryCard"
                                      alt="primaryCard"
                                    />
                                  </p>
                                </>
                              ) : (
                                <img
                                  loading="lazy"
                                  alt="delete"
                                  src={deleter}
                                  className="deleter"
                                  onClick={() => {
                                    data.is_default === 1
                                      ? setModalShow(false)
                                      : setModalShow(true);
                                    setCardID(data.business_card_id);
                                    setCardNumber(cardFourDigits);
                                  }}
                                />
                              )}
                              {i === checkedIndex && data.is_default !== 1 ? (
                                <div className="Tier-checkbox">
                                  <Form.Check
                                    aria-label="option 1"
                                    className="orange-checkbox"
                                    onChange={(e) =>
                                      UpdateDefaultCardHandler(
                                        e,
                                        data.business_card_id
                                      )
                                    }
                                    // checked={}
                                  />
                                  <p style={{ color: "#E66100" }}>
                                    Make it primary
                                  </p>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                            {i === checkedIndex ? (
                              <div
                                className={
                                  err === true ? "CVV-div errorCVV" : "CVV-div"
                                }
                              >
                                <input
                                  type="number"
                                  placeholder="CVV"
                                  value={cvv}
                                  onWheel={(e) => e.target.blur()}
                                  onChange={CvvHandler}
                                  min="0"
                                  max="9999"
                                ></input>
                                <img
                                  src={warningSymbol}
                                  className={
                                    i === checkedIndex && data.is_default !== 1
                                      ? "primaryOption"
                                      : "warningSymbol"
                                  }
                                  alt="warningSymbol"
                                />
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </Form>
                  <Link to="/my-profile/add-card">
                    <p className="Add-New">+ Add new card</p>
                  </Link>
                </Col> */}
                <Col md={12} className="checkout-summary">
                  <h3>Summary</h3>
                  <p>
                    {planDetails?.subscription_desc
                      ? planDetails?.subscription_desc
                      : "No Data Available!"}
                  </p>
                  {planDetails.subscription_id !== 1 ? (
                    <form className="apply_Coupon" onSubmit={handleSubmit}>
                      <p>Apply Coupon</p>
                      <input
                        placeholder="Apply Coupon"
                        onChange={applyChangeHandler}
                      ></input>
                      {applyButton === true && couponData !== "" ? (
                        <button
                          className="applied_Button"
                          id="applied_button"
                          onClick={alreadyApplied}
                        >
                          Applied
                        </button>
                      ) : (
                        <button type="submit">Apply</button>
                      )}
                    </form>
                  ) : (
                    <></>
                  )}
                  <ErrorLabel
                    ErrorDisplay={errorCoupon}
                    id={
                      errorCoupon === "Coupon applied successfully!"
                        ? "green_Text"
                        : ""
                    }
                  />
                  {discountedData &&
                  discountedData.message !== "Coupon is not valid" &&
                  couponData !== "" ? (
                    <i className="coupon_Description">
                      <span>{discountedData?.discount_percentage}</span> off for{" "}
                      <span>
                        {discountedData?.no_of_months}{" "}
                        {discountedData?.no_of_months === "Forever"
                          ? ""
                          : discountedData?.no_of_months > 1
                          ? "months"
                          : "month"}
                      </span>
                    </i>
                  ) : (
                    <></>
                  )}

                  <div className="Tier-amount">
                    <p>
                      {planDetails?.subscription_name
                        ? planDetails?.subscription_name
                        : ""}
                    </p>
                    <p>
                      :
                      <span>
                        <b>
                          ${" "}
                          {planDetails?.subscription_price
                            ? planDetails?.subscription_price
                            : 0}
                        </b>
                      </span>
                    </p>
                  </div>
                  {discountedData &&
                  discountedData.message !== "Coupon is not valid" &&
                  couponData !== "" ? (
                    <div className="Tier-amount discounted_Price">
                      <p>Discount value</p>
                      <p>
                        :
                        <span>
                          <b>
                            ${" "}
                            {discountedData
                              ? discountedData.discounted_price
                              : "0"}
                          </b>
                        </span>
                      </p>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="Tier-amount final">
                    <p>
                      <b>Total</b>
                    </p>
                    <p>
                      :
                      <span>
                        <b>
                          $
                          {discountedData &&
                          discountedData.message !== "Coupon is not valid" &&
                          couponData !== ""
                            ? discountedData.final_price
                            : planDetails?.subscription_price
                            ? planDetails?.subscription_price
                            : 0}
                        </b>
                      </span>
                    </p>
                  </div>
                  <div className="Tier-checkbox">
                    <Form.Check
                      aria-label="option 1"
                      className="orange-checkbox"
                      onChange={FormCheck}
                      checked={checked}
                    />
                    <p>
                      I accept the{" "}
                      <a
                        target="_blank"
                        href="http://meylah.com/termsofuse/"
                        className="t-c-checkout"
                      >
                        Terms & Conditions*
                      </a>{" "}
                    </p>
                  </div>
                </Col>
              </Row>
              <div className="checkout_Error_Message">
                <span className="star-required Errlabel-font_size">
                  {errDisplay}
                </span>
              </div>
              <div className="TierButtons">
                <Button onClick={cancelHandler} className="TierCancel">
                  Cancel
                </Button>
                <Button
                  // className={
                  //   cardDetails?.length > 0 &&
                  //   checkedIndex !== -1 &&
                  //   checked === true
                  //     ? "TierPay"
                  //     : "TierPay disable-button"
                  // }

                  // disabled={
                  //   cardDetails?.length > 0 &&
                  //   checkedIndex !== -1 &&
                  //   checked === true ? false : true
                  // }
                  // onClick={(e) => PayHandler(e)}
                  className="TierPay"
                  // disabled={checked === true ? false : true}
                  onClick={(e) =>
                    checked === true ? checkoutHandler(e) : e.preventDefault()
                  }
                  style={
                    checked === true
                      ? { cursor: "pointer", opacity: "1" }
                      : { cursor: "no-drop", opacity: "0.5" }
                  }
                >
                  Update subscription
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModalPopUp
        show={confirmationModalShow}
        onHide={() => setConfirmationModalShow(false)}
        ChargeBeeSubscriptionFuc={ChargeBeeSubscription}
        Data={subscriptionData}
        Price={
          planDetails?.subscription_price ? planDetails?.subscription_price : ""
        }
        plan={
          planDetails?.subscription_name ? planDetails?.subscription_name : ""
        }
      />
      <DeleteModal
        show={modalShow}
        DeleteFuc={DeleteCardHandler}
        Card_Id={cardID}
        CardNumber={cardNumber}
        onHide={() => setModalShow(false)}
      />
      <StripeModal
        SetLoading={setLoading}
        show={modalStripeShow}
        onHide={() => setStripeModalShow(false)}
        price={
          discountedData &&
          discountedData.message !== "Coupon is not valid" &&
          couponData !== ""
            ? discountedData.final_price
            : planDetails?.subscription_price
            ? planDetails?.subscription_price
            : 0
        }
        CouponData={couponData}
      />
      <PrivacyTermsConditions />
    </>
  );
};

export default CheckOutPage;
